import { useAppSelector } from '@common/hooks'
import { useLocation } from 'react-router-dom'
import { selectActiveRole, selectUser, selectTokens } from '../auth-slice'
import { PublicUserProfile } from '@app/services'
import { hasZid } from '@common/utils/tokens'
import { jwtDecode } from 'jwt-decode'
import { JwtPayload } from 'jwt-decode'

const useUser = (event_host_id?: number) => {
  const location = useLocation()
  const activeRole = useAppSelector(selectActiveRole)
  const selectedToken = useAppSelector(selectTokens)
  const isZid = hasZid(selectedToken?.access_token?.token)
  const Zid = isZid
    ? (jwtDecode(selectedToken?.access_token?.token) as JwtPayload & { zid?: string })
    : null

  const baseUser: PublicUserProfile =
    location.pathname === '/demo'
      ? {
          id: 93,
          username: 'Demo',
          email: 'demo@pengguin.com',
          bio: null,
          image: 'https://www.gravatar.com/avatar/ea618382a0c912bdec1c295b553deace',
          full_name: 'Demo',
          country: null,
          pronouns: 1,
          date_of_birth: null,
          learning: [
            {
              language: 'en',
              proficiency: 4,
            },
          ],
          address: null,
          speaking: [
            {
              language: 'en',
              proficiency: 4,
            },
          ],
          status: 'STUDENT',
          profile: null,
        }
      : useAppSelector(selectUser)

  // Update username and full_name if zID is present
  const user = Zid?.zid
    ? {
        ...baseUser,
        username: Zid.zid,
        full_name: Zid.zid,
      }
    : baseUser

  // Check if there's an active role override
  const isTeacher = activeRole === 'teacher' || user?.status === 'TEACHER'
  const isStudent = user?.status === 'STUDENT'

  const isAdmin =
    activeRole === 'admin' ||
    (activeRole === null && user?.roles && user?.roles.some((role) => role.name === 'SuperAdmin'))
  const isCompany = user?.is_company
  const isPartner = user?.profile?.partner

  // Safely handle user languages with proper null checks
  const userLanguages = (() => {
    if (!user || !user.speaking || !user.learning) return undefined

    const speakingLanguages = user.speaking
    const learningFiltered = user.learning.filter((item) => {
      const speakingLanguageCodes = speakingLanguages.map((e) => e.language)
      return !speakingLanguageCodes.includes(item.language)
    })

    return [...speakingLanguages, ...learningFiltered]
  })()

  const isHost = user?.id === event_host_id

  return { user, isAdmin, isTeacher, isStudent, userLanguages, isHost, isPartner, isCompany }
}

export default useUser
